export default __webpack_public_path__ + "static/media/link-icon.73003a34.svg";